import { SkyClubSpendTracker } from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  AEMErrorMessage,
  UserSession,
  getEmptyContent,
  isDisplay,
  isError
} from '@com-delta-idp/mnx-skymiles-shared';
import { SkyClubResponse } from '../models';
import { StatusTrackerResponse } from '../models/api/tracker.interfaces';
import { isValidSkyClubMember } from './amex-skyclub-tracker-card.adapter';
import { checkSkyClub } from './amex-skyclub-tracker.adapter';

export const checkAndReturnError = (
  aemErrorMessages: AEMErrorMessage[] | undefined,
  featureFlag: boolean | undefined
): SkyClubSpendTracker => {
  if (aemErrorMessages && aemErrorMessages.length > 0) {
    return isError<SkyClubSpendTracker>(
      'skyclub-tracker',
      aemErrorMessages,
      featureFlag
    );
  } else {
    return isDisplay<SkyClubSpendTracker>(featureFlag);
  }
};

export const checkEmptyError = (
  skyClub: SkyClubResponse,
  spendTracker: StatusTrackerResponse,
  profile: UserSession,
  featureFlag: boolean,
  aemErrorMessages: AEMErrorMessage[]
): SkyClubSpendTracker => {
  if (checkSkyClub(spendTracker, skyClub) && isValidSkyClubMember(profile)) {
    return isDisplay<SkyClubSpendTracker>(featureFlag);
  } else {
    return getEmptyContent<SkyClubSpendTracker>(
      'skyclub-tracker',
      aemErrorMessages,
      true
    );
  }
};
